import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraLogo, drawFooterEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFBrief (brief, empresa) {
      let pdfName = `brief_${brief.id}`; 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Brief',
        subject: 'Brief',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      /* Inicial */
      let positionInicialY = 75;
      /* Limite para el salto de página */
      let positionMaxY = 280;
      
      /* Interlineado */
      let interlineado = 4;

      let tieneMecanicaPromocional = false;
      if (brief.tiposDisenios) {
        let mecanicaPromocional = brief.tiposDisenios.find(t => (/true/i).test(t.mecanicaPromocional));
        if (mecanicaPromocional) {
          tieneMecanicaPromocional = true;
        }
      }

      drawCabecera(doc, empresa, brief, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
  
      /* Renglones */
      let positionY = positionInicialY;
      
      /* Especificaciones */
      doc.setFont(fontBoldName, 'bold');
      doc.text('ESPECIFICACIONES' , 10, positionY);

      doc.setDrawColor(210, 210, 210); 
      doc.setLineWidth(0.1);
      doc.line(10, positionY + 1, 60, positionY + 1);
      
      positionY += 8;
      positionY = drawText(doc, empresa, brief, 'Objetivo', brief.descripcion, 
        positionY, positionInicialY, positionMaxY, interlineado,
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);

      positionY += 4;
      doc.setFontSize(8);
      doc.setFont(fontBoldName, 'bold');
      doc.text('Tipos de Diseño' , 10, positionY);

      doc.setFontSize(8);
      doc.setFont(fontName, 'normal');
      if (brief.tiposDisenios) {
        brief.tiposDisenios.forEach(tipoDisenio => {
          positionY += 4;
          doc.text(`- ${tipoDisenio.tipoDisenio}`, 15, positionY);
        });
        positionY += 4;
      }

      positionY += 4;
      positionY = drawText(doc, empresa, brief, 'Adicionales', brief.adicionales, 
        positionY, positionInicialY, positionMaxY, interlineado,
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);

      if (tieneMecanicaPromocional) {
        positionY += 8;
        doc.setFont(fontBoldName, 'bold');
        doc.text('MECÁNICA PROMOCIONAL', 10, positionY);

        doc.setDrawColor(210, 210, 210); 
        doc.setLineWidth(0.1);
        doc.line(10, positionY + 1, 60, positionY + 1);

        positionY += 6;
        positionY = drawText(doc, empresa, brief, 'Titular', brief.titular, 
          positionY, positionInicialY, positionMaxY, interlineado,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);

        positionY += 2;
        positionY = drawText(doc, empresa, brief, 'Mecánica', brief.mecanica, 
          positionY, positionInicialY, positionMaxY, interlineado,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);

        positionY += 2;
        positionY = drawText(doc, empresa, brief, 'Premios', brief.premios, 
          positionY, positionInicialY, positionMaxY, interlineado,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);

        positionY += 2;
        positionY = drawText(doc, empresa, brief, 'Pie Legal', brief.pieLegal, 
          positionY, positionInicialY, positionMaxY, interlineado,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);

        positionY += 2;
        positionY = drawText(doc, empresa, brief, 'Adaptaciones', brief.piezas, 
          positionY, positionInicialY, positionMaxY, interlineado,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 2;
      }

      positionY += 2;
      positionY = drawText(doc, empresa, brief, 'Diseño de Visual', brief.requerimientosDisenio, 
        positionY, positionInicialY, positionMaxY, interlineado,
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);

      /* Marcas */
      if (positionY + 8 + 12 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 8;
      }
      doc.setFont(fontBoldName, 'bold');
      doc.text('MARCAS' , 10, positionY);

      doc.setDrawColor(210, 210, 210); 
      doc.setLineWidth(0.1);
      doc.line(10, positionY + 1, 60, positionY + 1);

      positionY += 2;

      doc.setFontSize(8);
      doc.setFont(fontName, 'normal');
      if (brief.marcas) {
        brief.marcas.forEach(marca => {
          if (positionY + 4 >= positionMaxY) {
            positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
                fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          } else {
            positionY += 4;
          }
          doc.text(marca.marca , 15, positionY);
        });
      }

      /* Entrega */
      if (positionY + 8 + 12 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 8;
      }
      doc.setFontSize(8);
      doc.setFont(fontBoldName, 'bold');
      doc.text('ENTREGA' , 10, positionY);

      doc.setDrawColor(210, 210, 210); 
      doc.setLineWidth(0.1);
      doc.line(10, positionY + 1, 60, positionY + 1);

      doc.setFontSize(8);
      doc.setFont(fontName, 'normal');

      if (positionY + 8 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 6;
      }
      doc.setFontSize(8);
      doc.setFont(fontBoldName, 'bold');
      doc.text('Forma de Entrega' , 10, positionY);

      doc.setFontSize(8);
      doc.setFont(fontName, 'normal');
      if ((/true/i).test(brief.formaEntregaEditable)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text('Voy a necesitar editable' , 15, positionY);
      }
      if ((/true/i).test(brief.formaEntregaDigital)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text('Las piezas serán sólo digitales' , 15, positionY);
      }
      if ((/true/i).test(brief.formaEntregaImpresion)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text('Las piezas se van a imprimir' , 15, positionY);
      }
      if ((/true/i).test(brief.formaEntregaAdaptacion)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text('Voy a necesitar adaptaciones para PPT' , 15, positionY);
      }
      if ((/true/i).test(brief.formaEntregaIndefinida)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text('Todavía no está definido' , 15, positionY);
      }
      if ((/true/i).test(brief.formaEntregaOtros)) {
        if (positionY + 4 >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        } else {
          positionY += 4;
        }
        doc.text(`Otra: ${brief.formaEntregaOtrosDescripcion}` , 15, positionY);
      }

      if (positionY + 12 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 6;
      }
      doc.setFontSize(8);
      doc.setFont(fontBoldName, 'bold');
      doc.text('Timing' , 10, positionY);

      doc.setFontSize(8);
      doc.setFont(fontName, 'normal');

      if (positionY + 4 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 4;
      }
      if (moment(brief.fechaEntregaMuestra).format('YYYY-MM-DD') == '1900-01-01') {
        doc.text('Primera Muestra: --', 10, positionY);
      } else {
        doc.text(`Primera Muestra: ${this.$options.filters.fechaHora(brief.fechaEntregaMuestra)}`, 10, positionY);
      }
      if (positionY + 4 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 4;
      }
      if (moment(brief.fechaEntregaOriginales).format('YYYY-MM-DD') == '1900-01-01') {
        doc.text('Originales: --', 10, positionY);
      } else {
        doc.text(`Originales: ${this.$options.filters.fechaHora(brief.fechaEntregaOriginales)}`, 10, positionY);
      }
      if (positionY + 4 >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      } else {
        positionY += 4;
      }
      if (moment(brief.fechaImplementacion).format('YYYY-MM-DD') == '1900-01-01') {
        doc.text('Implementación/Inicio: --', 10, positionY);
      } else {
        doc.text(`Implementación/Inicio: ${this.$options.filters.fechaHora(brief.fechaImplementacion)}`, 10, positionY);
      }

      drawFooterEmpresa(doc, empresa, fontName);

      /* Numeramos las páginas */
      for (let index = doc.internal.getNumberOfPages() - 1; index >= 0; index--) {
        doc.setPage(index + 1);
        doc.setFont(fontName, 'normal');
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        doc.text(`Página ${index + 1} de ${doc.internal.getNumberOfPages()}`, 10, 286);
      }

      window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));

      return;
    },
  }
}

function drawText(doc, empresa, brief, titulo, texto, 
  positionY, positionInicialY, positionMaxY, interlineado,
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  doc.setFontSize(8);
  doc.setFont(fontBoldName, 'bold');    
  doc.text(titulo, 10, positionY);
  
  doc.setFontSize(8);
  doc.setFont(fontName, 'normal');

  let lineasTexto = texto.split(/\r?\n/g);

  for (let linea = 0; linea < lineasTexto.length; linea++) {
    if (positionY + interlineado >= positionMaxY) {
      positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
          fontName, fontBoldName, fontItalicName, fontBoldItalicName);

    } else {
      positionY += interlineado;
    }

    let lineaTexto = lineasTexto[linea];

    if (lineaTexto.length > 130) {
      while (lineaTexto.length > 130) {
        if (positionY + interlineado >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        }
        let lastSpace = lineaTexto.substring(0, 130).search(/ [^ ]*$/);
        doc.text(lineaTexto.substring(0, lastSpace).trim(), 10, positionY);
        
        positionY += interlineado;

        lineaTexto = lineaTexto.substring(lastSpace + 1).trim();
      }
      if (lineaTexto.trim() != '') {
        if (positionY + interlineado >= positionMaxY) {
          positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
        }

        doc.text(lineaTexto.trim(), 10, positionY);
      }
    } else {
      if (positionY + interlineado >= positionMaxY) {
        positionY = addSaltoPagina(doc, empresa, brief, positionInicialY,
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      }

      doc.text(lineaTexto, 10, positionY);
    }
  }

  if (positionY + 5 >= positionMaxY) {
    /* Agregamos el footer */
    drawFooterEmpresa(doc, empresa, fontName);

    /* Agregamos una nueva pagina */
    doc.addPage();
    drawCabecera(doc, empresa, brief, 
      fontName, fontBoldName, fontItalicName, fontBoldItalicName);
    
    positionY = positionInicialY;

  } else {
    positionY += interlineado + 2;
  }
  
  return positionY;
}

function addSaltoPagina(doc, empresa, brief, positionInicialY,
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  /* Agregamos el footer */
  drawFooterEmpresa(doc, empresa, fontName);

  /* Agregamos una nueva pagina */
  doc.addPage();
  drawCabecera(doc, empresa, brief, 
    fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      
  let positionY = positionInicialY;

  doc.setFontSize(6);
  doc.setFont(fontName, 'normal');
      
  doc.text('Continuación ...', 15, positionY);

  doc.setFontSize(8);
  doc.setFont(fontName, 'normal');

  positionY += 4;
  
  return positionY;
}

function drawCabecera(doc, empresa, brief, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  drawCabeceraLogo(doc, empresa, fontName);

  /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(24);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Brief', 90, 20);

  /* Datos del cliente */
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);
  
  let positionY = 48;
  doc.text(`Nro. Brief: ${brief.id}`, 10, positionY);
  positionY += 4;
  doc.text(`Nro. Presupuesto: ${brief.presupuestoNumero}`, 10, positionY);
  positionY += 4;
  doc.text(`Cliente: ${brief.cliente.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Acción: ${brief.accion.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Canal: ${brief.canal.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Subcliente: ${brief.subcliente.trim()}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, 70, 200, 70);
}

